import { createContext, useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { api, TOKEN_KEY } from "@/lib/api";

const Ctx = createContext({ user: null });
export const useAuth = () => useContext(Ctx);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(localStorage.getItem(TOKEN_KEY) ? null : false);
  useEffect(() => {
    if (!localStorage.getItem(TOKEN_KEY)) return;
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => { localStorage.removeItem(TOKEN_KEY); setUser(false); });
  }, []);
  const devKey = (u) => `crm_device_${u}`;
  const finish = (data) => { localStorage.setItem(TOKEN_KEY, data.token); setUser(data.user); };
  const login = async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password, device: localStorage.getItem(devKey(username)) || "" });
    if (data.otp_required) return { ...data, username };
    finish(data);
    return null;
  };
  const verify = async (otp, code) => {
    const { data } = await api.post("/auth/verify", { challenge: otp.challenge, code });
    localStorage.setItem(devKey(otp.username), data.device);
    finish(data);
  };
  const logout = async () => {
    await api.post("/chat/presence", { status: "away" }).catch(() => {});
    sessionStorage.removeItem("chat_auto_presence");
    localStorage.removeItem(TOKEN_KEY); setUser(false);
  };
  return <Ctx.Provider value={{ user, login, verify, logout }}>{children}</Ctx.Provider>;
};

export const RequireAuth = ({ children }) => {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <div data-testid="auth-loading" className="flex min-h-screen items-center justify-center bg-[#0B0F17] text-sm text-slate-500">Carregando...</div>;
  if (!user) return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  return children;
};

export const RequireAdmin = ({ children }) => {
  const { user } = useAuth();
  return user?.role === "admin" ? children : <Navigate to="/" replace />;
};
